export const initialUsersTable = {
    data: [],
    loading: false
}